import React from 'react';
import StateSelector from './state_selector';

const StartNewProposal = () => {
  return (
    <div className="new-proposal-overlay" style={{ marginTop: '-20px', paddingTop: '0px', height: '100%' }}>
      <div className="content" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <div className="header">
          <div>
            <div className="page-header">
              <span className={'header qa-new-proposal-header'} style={{ fontSize: '30px' }}>
                Select homeowner's state to get started
                <div className={'subtitle'}>
                  If you don't see the state you want, please contact your admin to add a license for that state
                </div>
              </span>
            </div>
          </div>
        </div>

        <StateSelector mini={true} />
      </div>
    </div>
  );
};

export default StartNewProposal;
